import React from 'react';

type BadgeVariant = 'pending' | 'assigned' | 'inprogress' | 'completed' | 'disputed' | 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'cancelled' | 'reprocess';

interface BadgeProps {
  variant: BadgeVariant;
  label: string;
  size?: 'sm' | 'md';
}

const variantMap: Record<BadgeVariant, string> = {
  pending: 'bg-warning-bg text-warning border border-warning/20',
  assigned: 'bg-info-bg text-info border border-info/20',
  inprogress: 'bg-primary/10 text-primary border border-primary/20',
  completed: 'bg-success-bg text-success border border-success/20',
  disputed: 'bg-danger-bg text-danger border border-danger/20',
  success: 'bg-success-bg text-success border border-success/20',
  warning: 'bg-warning-bg text-warning border border-warning/20',
  danger: 'bg-danger-bg text-danger border border-danger/20',
  info: 'bg-info-bg text-info border border-info/20',
  neutral: 'bg-muted text-muted-foreground border border-border',
  cancelled: 'bg-muted text-muted-foreground border border-border',
  reprocess: 'bg-info-bg text-info border border-info/30',
};

export default function Badge({ variant, label, size = 'md' }: BadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1';
  return (
    <span className={`inline-flex items-center font-semibold rounded-full ${sizeClass} ${variantMap[variant]}`}>
      {label}
    </span>
  );
}